module.exports = "https://99designs-start-assets.imgix.net/js/9ae7b45d0abe7703f7eb41e4f23a6b0a.png";